<template>
  <div>
    <button
          v-if="!contentLoaing && questionsData.length == 0"
          type="button"
          @click="() => {this.canCreate = true;}"
          class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
          style="width: 30%"
      >
          <span>Создать тест</span>
      </button>

    <div v-if="!contentLoaing && (canCreate || questionsData.length > 0)">
      <ul
        style="width: 100%; margin-left: 10px"
        class="margin-t-15 space-y-1 text-gray-500 list-inside dark:text-gray-400 text-left mb-5"
      >
        <li 
          v-for="(el, ind) in questionsData" style="width: 100%"
          class="margin-bt-15" 
          :key="ind">
          <div style="font-size: 18px" class="font-semibold inl-100 mb-3 flex items-center gap-2">
            <div class="mr-3">{{ ind + 1 }}.</div>
            <input
              v-model="questionsData[ind].question"
              @input="markUnsavedChanges"
              placeholder="Создайте ответ"
              type="text"
              class="inl-90 h-10 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150 flex-1"
            />
            <span class="flex items-center gap-1 flex-shrink-0">
              <label class="text-xs text-gray-600 whitespace-nowrap">Баллы:</label>
              <input
                v-model.number="questionsData[ind].points"
                @input="markUnsavedChanges"
                type="number"
                min="0"
                max="100"
                class="h-10 border-0 px-2 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150 w-16"
              />
            </span>
            <button
              type="button"
              @click="deleteQuestion(ind)"
              class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-3 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150 flex-shrink-0"
              title="Удалить вопрос"
            >
              ✕
            </button>
          </div>

          <div
            v-for="(answer, answerInd) in el.question_answers"
            class="margin-bt-10 flex items-center gap-2"
            :key="answerInd"
          >
            <span>
              <input
                type="checkbox"
                @change="changeCorrectAnswer(ind, answerInd)"
                :checked="questionsData[ind].question_answers[answerInd].is_correct"
              />
            </span>
            <span class="pl-3 flex-1">
              <input
                v-model="questionsData[ind].question_answers[answerInd].answer"
                @input="markUnsavedChanges"
                placeholder="Создайте ответ"
                type="text"
                class="inl-90 h-10 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150 w-full"
              />
            </span>
            <button
              type="button"
              @click="deleteAnswer(ind, answerInd)"
              class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-3 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150 flex-shrink-0"
              title="Удалить ответ"
            >
              ✕
            </button>
          </div>

          <div>
            <span class="pl-3">
              <input
                v-on:keyup.enter="addAnswer($event, ind)"
                placeholder="Создайте ответ"
                type="text"
                class="inl-90 h-10 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150"
              />
            </span>
          </div>
        </li>
        
        <li style="width: 100%">
          <div 
            style="font-size: 18px" 
            class="margin-t-30 font-semibold inl-100 mb-3">
            <input
              v-on:keyup.enter="onQuestionEnter"
              placeholder="Создайте Вопрос"
              type="text"
              class="h-10 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
        </li>
      </ul>

    <button
          v-if="!contentLoaing && questionsData.length > 0"
          type="button"
          @click="saveData"
          :disabled="isSaving"
          class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-500"
          style="width: 30%"
      >
          <span v-if="!isSaving">Сохранить</span>
          <span v-else class="inline-flex items-center gap-2">
            <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Сохранение...
          </span>
      </button>

    </div>
  </div>
</template>

<script>
import { API_CLIENT, HEADERS_TOKEN_JSON } from "@/const/uri";
import axios from "axios";
import { mapActions } from 'vuex';
export default {
  emits: ['active'],
  data() {
    return {
      canCreate: false,
      contentLoaing: true,
      testResult: false,
      questionsData: [],
      isSaving: false,
      hasUnsavedChanges: false,
      draftSaveTimer: null,
    };
  },
  mounted() {
    this.loadData();
  },
  beforeUnmount() {
    clearTimeout(this.draftSaveTimer);
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  },
  beforeRouteUpdate(to, from, next) {
    this.loadData();
    next();
  },
  computed: {
    draftStorageKey() {
      return `tsor_questions_draft_${this.$route.params.themeUUID}`;
    },
  },
  methods: {
    ...mapActions(["toggleAlert"]),
    onBeforeUnload(e) {
      e.preventDefault();
      e.returnValue = '';
    },
    setBeforeUnload(active) {
      if (active) {
        window.addEventListener('beforeunload', this.onBeforeUnload);
      } else {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
      }
    },
    setUnsavedChanges(active) {
      this.hasUnsavedChanges = active;
      this.setBeforeUnload(active);
      this.$emit('active', active);
    },
    markUnsavedChanges() {
      this.setUnsavedChanges(this.questionsData.length > 0);
      this.scheduleDraftSave();
    },
    scheduleDraftSave() {
      clearTimeout(this.draftSaveTimer);
      this.draftSaveTimer = setTimeout(() => {
        this.saveDraft();
      }, 400);
    },
    saveDraft() {
      try {
        if (!this.hasUnsavedChanges || this.questionsData.length === 0) {
          localStorage.removeItem(this.draftStorageKey);
          return;
        }

        localStorage.setItem(this.draftStorageKey, JSON.stringify({
          savedAt: new Date().toISOString(),
          questionsData: this.questionsData,
        }));
      } catch (error) {
        console.error("Ошибка при сохранении черновика теста:", error);
      }
    },
    clearDraft() {
      clearTimeout(this.draftSaveTimer);
      localStorage.removeItem(this.draftStorageKey);
    },
    restoreDraft() {
      const rawDraft = localStorage.getItem(this.draftStorageKey);
      if (!rawDraft) return;

      try {
        const draft = JSON.parse(rawDraft);
        if (!Array.isArray(draft.questionsData)) return;

        const shouldRestore = window.confirm(
          "Найден несохраненный черновик теста. Восстановить его?"
        );
        if (!shouldRestore) {
          return;
        }

        this.questionsData = draft.questionsData;
        this.setUnsavedChanges(this.questionsData.length > 0);
        this.toggleAlert({
          message: "Черновик теста восстановлен",
          isError: false,
        });
      } catch (error) {
        console.error("Ошибка при восстановлении черновика теста:", error);
        this.clearDraft();
      }
    },
    showExpiredSessionAlert() {
      this.toggleAlert({
        message: "Сохранение не выполнено: сессию не удалось продлить автоматически. Черновик сохранен локально.",
        isError: true,
      });
    },
    changeCorrectAnswer(ind, answerInd) {
      // Теперь поддерживаем множественные правильные ответы
      this.questionsData[ind].question_answers[answerInd].is_correct =
        !this.questionsData[ind].question_answers[answerInd].is_correct;
      this.markUnsavedChanges();
    }, 
    addAnswer($event, ind) {
      const value = $event.target.value;
      if(value == '') return;
      this.questionsData[ind]['question_answers'].push({
        answer: value,
        is_correct: false,
      });
      $event.target.value = '';
      this.markUnsavedChanges();
    },
    deleteAnswer(questionInd, answerInd) {
      const answer = this.questionsData[questionInd].question_answers[answerInd];
      if (answer.id) {
        this.deleteAnswerFromAPI(answer.id, questionInd, answerInd);
      } else {
        this.questionsData[questionInd].question_answers.splice(answerInd, 1);
        this.markUnsavedChanges();
      }
    },
    async deleteAnswerFromAPI(answerId, questionInd, answerInd) {
      try {
        await axios({
          method: "DELETE",
          url: `${API_CLIENT.adminTsorAnswers}${answerId}/`,
          headers: HEADERS_TOKEN_JSON(),
          skipAuthRedirect: true,
        });
        this.questionsData[questionInd].question_answers.splice(answerInd, 1);
        this.markUnsavedChanges();
        this.toggleAlert({
          message: "Ответ успешно удален",
          isError: false,
        });
      } catch (error) {
        console.error("Ошибка при удалении ответа:", error);
        if (error.response?.status === 401) {
          this.saveDraft();
          this.showExpiredSessionAlert();
          return;
        }
        this.toggleAlert({
          message: "Ошибка при удалении ответа",
          isError: true,
        });
      }
    },
    deleteQuestion(questionInd) {
      const question = this.questionsData[questionInd];
      if (question.id) {
        this.deleteQuestionFromAPI(question.id, questionInd);
      } else {
        this.questionsData.splice(questionInd, 1);
        this.markUnsavedChanges();
      }
    },
    async deleteQuestionFromAPI(questionId, questionInd) {
      try {
        await axios({
          method: "DELETE",
          url: `${API_CLIENT.adminTsorQuestionsItem}${questionId}/`,
          headers: HEADERS_TOKEN_JSON(),
          skipAuthRedirect: true,
        });
        this.questionsData.splice(questionInd, 1);
        this.markUnsavedChanges();
        this.toggleAlert({
          message: "Вопрос успешно удален",
          isError: false,
        });
      } catch (error) {
        console.error("Ошибка при удалении вопроса:", error);
        if (error.response?.status === 401) {
          this.saveDraft();
          this.showExpiredSessionAlert();
          return;
        }
        this.toggleAlert({
          message: "Ошибка при удалении вопроса",
          isError: true,
        });
      }
    },
    onQuestionEnter(e) {
      const val = e.target.value;
      if(val == '') return;
      this.questionsData.push({
        question: val,
        question_answers: [],
        points: 1,
      });
      e.target.value = '';
      this.markUnsavedChanges();
    },
    validateQuestions() {
      for (let qInd = 0; qInd < this.questionsData.length; qInd++) {
        const question = this.questionsData[qInd];
        if (!question.question.trim()) {
          this.toggleAlert({
            message: `Вопрос ${qInd + 1}: Текст вопроса не может быть пустым`,
            isError: true,
          });
          return false;
        }

        const hasCorrectAnswer = question.question_answers.some(answer => answer.is_correct);
        if (!hasCorrectAnswer) {
          this.toggleAlert({
            message: `Вопрос "${question.question}": Должен быть отмечен хотя бы один правильный ответ`,
            isError: true,
          });
          return false;
        }

        const hasAnswers = question.question_answers.length > 0;
        if (!hasAnswers) {
          this.toggleAlert({
            message: `Вопрос "${question.question}": Должен быть хотя бы один ответ`,
            isError: true,
          });
          return false;
        }
      }
      return true;
    },

    async saveData() {
      if (this.isSaving) return; // Защита от двойного клика

      if (!this.validateQuestions()) {
        return;
      }

      this.isSaving = true;
      try {
        await axios({
          method: "PUT",
          url: API_CLIENT.adminQuestions + this.$route.params.themeUUID+ "/",
          headers: HEADERS_TOKEN_JSON(),
          skipAuthRedirect: true,
          data: {
            questions_data: this.questionsData,
          },
        });

        this.clearDraft();
        this.setUnsavedChanges(false);
        this.toggleAlert({
          message: "Вопросы успешно обновлен",
          isError: false,
        });
      } catch (error) {
        console.error("Ошибка при сохранении вопросов:", error);
        this.saveDraft();

        if (error.response?.status === 401) {
          this.showExpiredSessionAlert();
          return;
        }

        this.toggleAlert({
          message: "Ошибка при сохранении вопросов",
          isError: true,
        });
      } finally {
        this.isSaving = false;
      }
    },
    async loadData() {
      await axios({
        method: "GET",
        url: API_CLIENT.adminQuestions + this.$route.params.themeUUID + "/",
        headers: HEADERS_TOKEN_JSON(),
        data: {},
      })
        .then((e) => {
          this.questionsData = e.data.data.questions;
          this.contentLoaing = false;
          this.setUnsavedChanges(false);
          this.restoreDraft();
        })
        .catch(function (e) {
          console.log(e);
        });
    },
  },
  props: {
    questionUUID: {},
    canEdit: {},
  },
};
</script>